import { render, staticRenderFns } from "./twoflanks.vue?vue&type=template&id=b599290e&"
import script from "./twoflanks.vue?vue&type=script&lang=js&"
export * from "./twoflanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports